(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangesDeleteController',ChangesDeleteController);

    ChangesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Changes'];

    function ChangesDeleteController($uibModalInstance, entity, Changes) {
        var vm = this;
        vm.changes = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Changes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
